module.exports = __webpack_public_path__ + "img/report.19d07e47.png";